import { Button } from 'antd';
import { useCurrentUser } from '../../shared/features/session/components/CurrentUserProvider';
import { useImpersonation } from '../../shared/features/session/hooks/use-impersonation';

/** Not dismissible: while an admin is acting as someone, every screen must say so. Renders nothing otherwise. */
export function ImpersonationBanner() {
  const { state } = useCurrentUser();
  const { stop } = useImpersonation();

  if (state.status !== 'authenticated' || !state.user.impersonation) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-b border-warning/40 bg-warning/15 px-4 py-2 text-sm text-fg"
    >
      <span className="min-w-0">
        Acting as <strong>{state.user.name}</strong>. Signed in as {state.user.impersonation.impersonatorName}; everything you do is recorded under their name.
      </span>
      <Button size="small" onClick={() => void stop()}>
        Stop acting as {state.user.name}
      </Button>
    </div>
  );
}
